<template>
  <v-container id="bid-decision" fluid tag="section" class="grow d-flex flex-column">
    <v-row class="grow">
      <v-col cols="12" lg="9">
        <idc-component-bid-decision-table
          :bid-number="bidNumber"
          :customer="customer"
          :decision-settings="bidDecisionSettings"
          :decision-criteria="bidDecisionCriteriaSets"
          @validation="validation"
        />
      </v-col>
      <v-col cols="12" lg="3" align="center" class="grow">
        <idc-component-bid-decision-approval />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import Path from '@/utilities/bid/enums/Path'
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'

  export default Vue.extend({
    name: 'DashboardBidDecision',
    components: {
      IdcComponentBidDecisionTable: () => import('@/components/idc/bids/decision/Director'),
      IdcComponentBidDecisionApproval: () => import('@/components/idc/bids/decision/Approval'),
    },
    computed: {
      ...mapState('Bid', ['bidNumber', 'customer', 'bidDecision', 'bidDecisionCriteriaSets', 'bidDecisionSettings']),
      ...mapState('Bid', ['decisionSet']),
      ...mapGetters('Bid', ['getBidDecision']),
    },
    created() {
      if (this.bidNumber !== null) {
        this.fetchDecisionSet(this.bidNumber)
      } else {
        this.$router.push(Path.SALES_BIDS_SUMMARY)
      }
    },
    methods: {
      ...mapActions('Bid', ['fetchDecisionSet']),
      ...mapMutations('Bid', ['setBidDecision']),
      validation(value) {
        this.isValid = value
      },
    },
  })
</script>

<style lang="sass">
  section#bid-decision
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important

    .v-data-table__wrapper
      overflow-x: hidden
      overflow-y: hidden

    .v-data-table__mobile-row__header
      margin-right: 20px

    table
      td
        div.col-12
          padding-top: 1px !important
          padding-bottom: 1px !important
</style>
